var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 19v-5.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C12.24 12 11.96 12 11.4 12H8.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7 12.76 7 13.04 7 13.6V19m10 0V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C15.48 1 14.92 1 13.8 1H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 2.52 3 3.08 3 4.2V19m16 0H1M8 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z",
    stroke: "#006997",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding01);
export default __webpack_public_path__ + "static/media/building-01.9fd3630f56239a9fa750e8acd1827e64.svg";
export { ForwardRef as ReactComponent };